import React from 'react';
import {ListViewProvider, useListView} from "./core/ListViewProvider";
import {PageListHeader} from "./components/header/PageListHeader";
import PageTable from "./table/PageTable";
import {QueryRequestProvider} from "./core/QueryRequestProvider";
import {QueryResponseProvider} from "./core/QueryResponseProvider";
import {KTCard} from "../../../../_metronic/helpers";


const PageList = () => {

    return (
        <>
            <KTCard>
                <PageListHeader />
                <PageTable />
            </KTCard>
        </>
    );
};

const PageListWrapper =()=>{
    return(
        <QueryRequestProvider>
            <QueryResponseProvider>
                <ListViewProvider>
                    <PageList />
                </ListViewProvider>
            </QueryResponseProvider>
        </QueryRequestProvider>
    )
}
export {PageListWrapper}